import type { Action } from '../actions/types';

export type AuthUser = Readonly<{
  jwt: string;
  id: string;
  email: string;
  roles: ReadonlyArray<string>;
}>;

export type AuthState = Readonly<{
  user: AuthUser | null;
}>;

const initialState: AuthState = {
  user: null,
};

export default function (
  state: AuthState | null | undefined = initialState,
  action: Action
): AuthState {
  switch (action.type) {
    case 'LOGIN':
      return { user: action.payload };
    case 'LOGOUT':
      return initialState;
    default:
      return state ?? initialState;
  }
}

export function isAgency(authUser: AuthUser) {
  return (authUser.roles || []).includes('ROLE_AGENCY');
}
